import React, { useState,useContext } from "react";

import "bootstrap/dist/css/bootstrap.min.css";

import { useNavigate } from "react-router-dom";
import "./../../Shared/Home.css";
import LocationInput from "./LocationInput";
import { useLocation } from "react-router-dom";
import { baseUrl } from "./../../Apiurls/Apiurls";
import { AuthContext } from "./../../Contextapi/ContextApi";
import Navbar from "../../Shared/Navbar";

function UploadApplication() {
  const navigate = useNavigate();
  const location = useLocation();
  
const { userId,logout} = useContext(AuthContext);
  const handleNavigation = (path) => {
    navigate(path, );
  };


  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [resetLocationKey, setResetLocationKey] = useState(0);

  const initialFormData = {
    name: "",
    age: "",
    contactNo: "",
    location: "",
    educationQualification: "",
    organisation: "",
    intermediateStream: "",
    diplomaCourse: "",
    btechBranch: "",
    beBranch: "",
    designation: "",
    email: "",
    gender: "",
    totalExperienceYears: "",
    totalExperienceMonths: "",
    positionsSuitableFor: "",
    resume: null,
    skills: "",
  };

  const [formData, setFormData] = useState({ ...initialFormData });

  const handleLocationChange = (locationValue) => {
    setFormData({
      ...formData,
      location: locationValue,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      resume: file,
    });
  };

  const validateForm = () => {
    const newErrors = {};
    Object.keys(initialFormData).forEach((field) => {
      if (!formData[field] && field !== "intermediateStream" && field !== "diplomaCourse" && field !== "btechBranch" && field !== "beBranch") {
        newErrors[field] = "This field is required";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

 

const handleSubmit = async (e) => {
  e.preventDefault();

  if (isSubmitting) return;
  if (!validateForm()) return;

  setIsSubmitting(true);

  try {
    const totalExperience = `${formData.totalExperienceYears} years ${formData.totalExperienceMonths } months`;

    const formDataToSend = new FormData();

    // append form fields except resume
    for (const key in formData) {
      if (key !== "resume") {
        formDataToSend.append(key, formData[key]);
      }
    }

    // append calculated experience
    formDataToSend.append("totalExperience", totalExperience);

    // append resume file if selected
    if (formData.resume) {
      formDataToSend.append("resume", formData.resume);
    }

    // ✅ append userId from AuthContext
    formDataToSend.append("userId", userId);

    const response = await fetch(`${baseUrl}/api/upload`, {
      method: "POST",
      body: formDataToSend,
    });

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.error || "Submission failed");
    }

    alert("Form data submitted successfully!");

    // reset form
    setFormData({ ...initialFormData });
    document.getElementById("resumeInput").value = "";

  } catch (error) {
    console.error(error);
    alert(error.message);
  } finally {
    setIsSubmitting(false);
  }
};


  const handleLogout = () => {
    logout();
    alert("You have successfully logged out");
    navigate("/");
  };

  return (
    <>
      
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-2">
              <Navbar/>
            </div>
            <div className="col-md-10">
              <div className="container-xl d-flex justify-content-center align-items-center vh-100">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title text-center mb-5 fw-bold">
                      Upload Application
                    </h5>
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="fw-bold">Name</label>
                            <input
                              type="text"
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              className="form-control"
                            />
                            {errors.name && <small className="text-danger">{errors.name}</small>}
                          </div>
                          <div className="form-group">
                            <label className="fw-bold">Age</label>
                            <input
                              type="text"
                              name="age"
                              value={formData.age}
                              onChange={handleChange}
                              className="form-control"
                            />
                            {errors.age && <small className="text-danger">{errors.age}</small>}
                          </div>
                          <div className="form-group">
                            <label className="fw-bold">Contact No.</label>
                            <input
                              type="text"
                              name="contactNo"
                              value={formData.contactNo}
                              onChange={handleChange}
                              className="form-control"
                            />
                            {errors.contactNo && <small className="text-danger">{errors.contactNo}</small>}
                          </div>
                          <LocationInput
                  onLocationChange={handleLocationChange}
                  resetLocationKey={resetLocationKey}
                />
                          {errors.location && <small className="text-danger">{errors.location}</small>}
                          <div className="form-group">
                            <label className="fw-bold">Education Qualification</label>
                            <select
                              name="educationQualification"
                              value={formData.educationQualification}
                              onChange={handleChange}
                              className="form-control"
                            >
                              <option value="">Select Qualification</option>
                              <option value="10th">10th</option>
                              <option value="Intermediate">Intermediate</option>
                              <option value="Diploma">Diploma</option>
                              <option value="Btech">Btech</option>
                              <option value="B.E">B.E</option>
                              <option value="BA">BA</option>
                              <option value="B.com">B.com</option>
                              <option value="PGDM">PGDM</option>
                              <option value="MBA">MBA</option>
                              <option value="Postgraduate">Postgraduate</option>
                              <option value="Bsc">Bsc</option>
                              <option value="other">Other</option>
                            </select>
                            {errors.educationQualification && <small className="text-danger">{errors.educationQualification}</small>}
                            {formData.educationQualification === "other" && (
                              <input
                                type="text"
                                name="otherQualification"
                                value={formData.otherQualification}
                                onChange={handleChange}
                                placeholder="Enter Other Qualification"
                                className="form-control mt-3"
                              />
                            )}
                          </div>
                          <div className="form-group">
                            <label className="fw-bold">Organisation</label>
                            <input
                              type="text"
                              name="organisation"
                              value={formData.organisation}
                              onChange={handleChange}
                              className="form-control"
                            />
                            {errors.organisation && <small className="text-danger">{errors.organisation}</small>}
                          </div>
                          <div className="form-group">
                            <label className="fw-bold">Designation</label>
                            <input
                              type="text"
                              name="designation"
                              value={formData.designation}
                              onChange={handleChange}
                              className="form-control"
                            />
                            {errors.designation && <small className="text-danger">{errors.designation}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="fw-bold">Email</label>
                            <input
                              type="email"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              className="form-control"
                            />
                            {errors.email && <small className="text-danger">{errors.email}</small>}
                          </div>
                          <div className="form-group">
                            <label className="fw-bold">Gender</label>
                            <select
                              name="gender"
                              value={formData.gender}
                              onChange={handleChange}
                              className="form-control"
                            >
                              <option value="">Select Gender</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                             
                            </select>
                            {errors.gender && <small className="text-danger">{errors.gender}</small>}
                          </div>
                          <div className="form-group">
                            <label className="fw-bold">Total Experience</label>
                            <div className="d-flex">
                              <input
                                type="number"
                                name="totalExperienceYears"
                                value={formData.totalExperienceYears}
                                onChange={handleChange}
                                placeholder="Years"
                                className="form-control me-2"
                              />
                              <input
                                type="number"
                                name="totalExperienceMonths"
                                value={formData.totalExperienceMonths}
                                onChange={handleChange}
                                placeholder="Months"
                                className="form-control"
                              />
                            </div>
                            {errors.totalExperienceYears && <small className="text-danger">{errors.totalExperienceYears}</small>}
                            {errors.totalExperienceMonths && <small className="text-danger">{errors.totalExperienceMonths}</small>}
                          </div>
                          <div className="form-group">
                            <label className="fw-bold">Positions Suitable For</label>
                            <textarea
                              name="positionsSuitableFor"
                              value={formData.positionsSuitableFor}
                              onChange={handleChange}
                              className="form-control"
                              rows="3"
                            />
                            {errors.positionsSuitableFor && <small className="text-danger">{errors.positionsSuitableFor}</small>}
                          </div>

                          <div className="form-group mt-2">
                            <label className="fw-bold">Skills</label>
                            <input
                              type="text"
                              name="skills"
                              value={formData.skills}
                              onChange={handleChange}
                              className="form-control"
                            />
                            {errors.skills && <small className="text-danger">{errors.skills}</small>}
                          </div>
                          <div className="form-group mt-1">
                            <label className="fw-bold">Upload Resume</label>
                            <input
                              id="resumeInput"
                              type="file"
                              name="resume"
                              accept=".pdf, .doc, .docx"
                              onChange={handleFileChange}
                              className="form-control"
                            />
                            {errors.resume && <small className="text-danger">{errors.resume}</small>}
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-center">
                        <button
                          type="submit"
                          className="btn btn-primary mt-4"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? "Submitting..." : "Submit"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
     
    </>
  );
}

export default UploadApplication;
